import { gql } from 'apollo-boost';

export const allocationsByInvestmentId = gql`
  query ($id: ID) {
    allInvestments(filters: {id: $id}) {
      edges {
          node {
              dbId
              message
              allocations {
                  edges {
                      node {
                          dbId
                      }
                  }
              }
          }
      }
    }
  }
`;
